import { useFeatureFlagEnabled } from 'posthog-js/react';

import { useGetUserMe } from '@/api/REST/userMe';
import { FEATURE_FLAGS } from '@/constants/featureFlags';
import { isTest } from '@/legacy/utils/env';

export const useHasDashboardsReporting = () => {
  const { hasLegacyBillingPlan } = useGetUserMe();

  const rollOutEnabled = useFeatureFlagEnabled(
    FEATURE_FLAGS.DASHBOARDS_REPORTING,
  );

  if (hasLegacyBillingPlan || isTest) {
    return false;
  }

  return rollOutEnabled;
};
